import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "app/admin/admin.service";
import { ApiService } from "app/modules/shared/services/api.service";
import { UserData } from "app/shared/service/UserService";
import { AlertMessage } from "app/shared/utils/alertMessage";
import * as moment from "moment";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import { TeamsListDialogComponent } from "./teams-list-dialog/teams-list-dialog.component";
import * as _ from "underscore";
import { HelperService } from "app/modules/shared/services/helper.service";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-user-details",
  templateUrl: "./user-details.component.html",
  styleUrls: ["./user-details.component.scss"],
  providers: [DatePipe],
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  subSink: Subscription;
  @Input() name: any;
  @Input() pSetName: any;
  @Output() exit = new EventEmitter();
  userData: any = {
    userDetails: undefined,
    teams: undefined,
    practiceSets: undefined,
    lessons: undefined,
    userName: undefined,
  };
  showTeamTab: boolean = false;
  userRole: any;
  isPageLoad: boolean = false;
  dateRangeType = "Day";
  datePickerEvent: any = {
    type: "Day",
    from: moment(new Date()).format("YYYY-MM-DD"),
    to: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"),
    count: 30,
    apiUrl: "userSessionsPlayedUsage",
    selectedApp: null,
  };
  completedPracticeSets: any = [];
  completedLessons: any = [];
  type = {};
  subSink1: Subscription;
  teamData: any;
  userName: string = "hub_admin";
  isMobileDevice: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public api: ApiService,
    public router: Router,
    private teamsDialog: MatDialog,
    private adminService: AdminService,
    private helperService: HelperService,
    private crypto: CryptoService,
  ) {
    this.organizationId = "noOrg";
    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != "") this.organizationId = UserData.organizationId;
    else if (!_.isUndefined(localStorage.getItem("organizationId"))) this.organizationId = localStorage.getItem("organizationId");
    this.organizationId = this.organizationId == null ? "noOrg" : this.organizationId; 
    this.isMobileDevice = this.helperService.getIsMobileDevice();  
  }

  getDate(e) {
    this.datePickerEvent = e;
    this.api.changeMessage(e);
  }

  async getUserDetails(name) {
    this.userData.userDetails = undefined;
    let nameStr = this.crypto.isProbablyEncrypted(name) ? name : await this.crypto.encryptData(name);
    this.api.get("/analytics/UserAnalyticsDetails/" + nameStr + (this.selectedApp.id ? "?gameId=" + this.selectedApp.id : "")).subscribe(
      async (success) => {
        if (success && success[0]) {
          this.userData.userDetails = success[0];

          if (this.userData.userDetails.email) {
            this.userData.userDetails.emailDec = await this.crypto.decryptData(this.userData.userDetails.email);
          }

          if (this.userData.userDetails.username) {
            this.userData.userDetails.usernameDec = 
            this.crypto.isProbablyEncrypted(this.userData.userDetails.username) ? await this.crypto.decryptData(this.userData.userDetails.username)
              : this.userData.userDetails.username;
          }

          this.userData.userDetails.nameIcon = success[0].userRole == "Guest" ? success[0].username.substring(0, 2) : success[0].firstName.split("")[0] + success[0].lastName.split("")[0];
        } else {
          this.userData.userDetailsMessage = "No data found";
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  async getTeams(name) {
    this.userData.teams = undefined;
    let team = [];
    let nameStr = this.crypto.isProbablyEncrypted(name) ? name : await this.crypto.encryptData(name);
    this.api.get("/analytics/UserAnalyticsTeamsDetails/" + nameStr + (this.selectedApp.id ? "?gameId=" + this.selectedApp.id : "")).subscribe(
      (success) => {
        if (success) {
          //SG-7364
          const copiedData = JSON.parse(JSON.stringify(success));
          this.teamData = copiedData;
          success.forEach((team) => {
            delete team.description;
            delete team.joinableTeams;
            delete team.teamLevelRole;
          });
          this.userData.teams = success.map((team) => {
            const ob = { value: team.teamID, hide: true };
            team.teamID = ob;
            return team;
          });
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  getPracticeSet(name) {
    this.isload = true;
    this.api.get("/analytics/UserAnalyticsCompletedPracticeSetDetails/" + name + (this.selectedApp.id ? "?gameId=" + this.selectedApp.id : "")).subscribe(
      (success) => {
        if (success) {
          this.userData.practiceSets = success.map((ps) => {
            const name = ps.practiceSet.split(" ");
            ps = {
              nameIcon: (name[0].split("")[0] ? name[0].split("")[0] : "") + (name[1] ? name[1].split("")[0] : (name[0].split("")[1] ? name[0].split("")[1] : "") ? name[0].split("")[1] : ""),
              ...ps,
            };
            ps["completionDate"] = moment(new Date(ps["completionDate"])).format("MMMM D, YYYY");
            const ob = { value: ps.practiceSetId, hide: true };
            ps.practiceSetId = ob;
            return ps;
          });
          this.isload = false;
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  isLessonload: boolean = false;

  openTeamsDialog(e) {
    //disabled on mobile
    if(!this.isMobileDevice){
      //SG-7364
      let data = this.teamData.filter((data) => data.teamID == e.row.teamID.value);
      const teamData = {
        isTeamAnalytics: true,
        id: data[0].teamID,
        name: data[0].teamName,
        joinableTeams: data[0].joinableTeams == "Yes" ? true : false,
        teamType: data[0].joinableTeams == "Yes" ? "Public" : "Private",
        description: data[0].description,
        teamLevelRole: data[0].teamLevelRole,
      };
      this.api.teamAnalytics = teamData;
      this.router.navigate(["main/memberTeams"]);
      // let dialogRef = this.teamsDialog.open(TeamsListDialogComponent, {
      //   width: '900px',
      //   data: { teamName: e.row.teamName, role: e.row.role, teamId: e.row.teamID.value, userRole: this.userRole }
      // });
    }
  }

  public fetchUserDetails(token) {
    this.adminService.getUserDetails(token).subscribe(
      (res) => {
        let dataObject: any = res;
        let apiKeyRes = dataObject;
        this.userRole = apiKeyRes.userRole;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  openPSetAnalytics(e) {
    if (this.name) {
      this.exit.emit({ row: e.row, key: "pSetAnalytics" });
    } else if (e.col == "practice Set") {
      this.router.navigate(["main/practiceSet/analytics", e.row.practiceSetId.value, e.row.practiceSet, this.userData.userName]);
    } else if (e.col.trim() == "lesson") {
      this.router.navigate(["main/practiceSet/analytics", e.row.practiceSetId.value, e.row.lesson, this.userData.userName]);
    }
  }

  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  ngOnInit() {
   /* if (this.selectedApp && this.selectedApp?.title == "STARS Keyboard") {
      this.api.newAppBreadcrumb = true;
      this.api.showApplibraryList = true;
      if (this.name) {
        this.api.addRoute(0, this.name);
        this.userData.userName = this.name;
        this.getDetails();
      } else {
        this.route.params.subscribe((data) => {
          if (data.name) {
            let name = data.name;
            const val: string = data.name;
            if (val.includes("?")) {
              name = val.split("?")[0];
            }
            this.api.addRoute(0, name);
            this.userData.userName = name;
            this.getDetails();
          }
        });
      }
      this.route.queryParams.subscribe((params) => {
        if (params["view"] && params["view"] === "membersAnalytics") {
          this.showTeamTab = true;
        } else {
          this.showTeamTab = false;
        }
      });

      this.route.data.forEach((data) => {
        if (data.data.singleOrgApp) {
          UserData.organizationId = data.data.organizationId;
          UserData.roles = data.data.roles;
          UserData.singleOrgApp = data.data.singleOrgApp;
          UserData.subRoles = data.data.subRoles;
          // this.fetchUserDetails(UserData.token);
        }
      });
      return;
    }*/
    // **************SG-7048 ***************
    if (!window.location.href.includes("isRedirection=yes")) {
      localStorage.removeItem("dateRange");
    } else {
      this.dateRangeType = localStorage.getItem("dateRange");
    }
    this.subSink1 = this.helperService.selectedCompletedAppDataa$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      if (next) {
        this.selectedApp = next;
        if (window.location.href.includes("isRedirection=yes")) {
          this.type = JSON.parse(this.dateRangeType);
        } else {
          this.type = {
            type: "Day",
          };
        }
        this.initData();
        this.isPageLoad = true;
      }
    });
    this.subSink = this.api.completeDateRange$.subscribe((next) => {      
      if (next) {
        if (this.userData.userName) {
          this.type = next;
          if (this.selectedApp?.title != "Advanced Vectoring" && this.selectedApp?.title != "Basic Vectoring"
             && this.selectedApp?.title != "STARS Keyboard"
          ) this.getCompletedPracticeSet(next, this.userData.userName);
        }
      }
    });

    this.api.newAppBreadcrumb = true;
    this.api.showApplibraryList = true;
    if (this.name) {
      if(this.isMobileDevice){
        this.api.addMobileRouteForUserDetailsFromMemberAndTeam(this.name);
      } else {
        this.api.addRoute(0, this.name);
      }
      this.userData.userName = this.name;
      this.getDetails();
    } else {
      this.route.params.subscribe((data) => {
        if (data.name) {
          let name = data.name;
          const val: string = data.name;
          if (val.includes("?")) {
            name = val.split("?")[0];
          }
          if(this.isMobileDevice){
            this.api.addMobileRouteForUserDetailsFromMemberAndTeam(name);
          } else {
            this.api.addRoute(0, name);
          }
          this.userData.userName = name;
          this.getDetails();
        }
      });
    }
    this.route.queryParams.subscribe((params) => {
      if (params["view"] && params["view"] === "membersAnalytics") {
        this.showTeamTab = true;
      } else {
        this.showTeamTab = false;
      }
    });

    this.route.data.forEach((data) => {
      if (data.data.singleOrgApp) {
        UserData.organizationId = data.data.organizationId;
        UserData.roles = data.data.roles;
        UserData.singleOrgApp = data.data.singleOrgApp;
        UserData.subRoles = data.data.subRoles;
        // this.fetchUserDetails(UserData.token);
      }
    });
  }

  appList: any = [];
  appPermissionList: any[] = [];
  breadCrumb: any[] = [];
  selectedApp: any;
  appLibraryList: any[] = [];
  isAdmin: boolean = false;
  organizationId: any = "";

  getDetails() {
    this.api.get("/organizations/" + this.organizationId + "/userDetails/").subscribe(
      (success) => {
        if (!_.isUndefined(success)) {
          // ***********  SG-7203 start*************************

          let dataObject: any = success;
          let apiKeyRes = dataObject;
          this.userRole = apiKeyRes.userRole;
          // ***********  SG-7203 end*************************

          if (success.userRole == "Admin" || success.userRole == "Owner") this.isAdmin = true;
          this.getPermissionApps(success.username, "APPL");
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  getPermissionApps(userName, appCode) {
    this.api.get("/organizations/" + this.organizationId + "/getSubAppPermissionByUserName?userName=" + userName + "&&appId=" + appCode).subscribe(
      (success) => {
        if (!_.isUndefined(success)) {
          this.appPermissionList = success;
          this.getAppData();
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }
  getAppData() {
    this.appList = [];
    this.appLibraryList = [];
    let firstData: any;
    this.api.get("/organizations/" + this.organizationId + "/getApps").subscribe(
      (success) => {
        if (!_.isUndefined(success.Games)) {
          this.appList = success.Games.map((data) => {
            data = {
              id: data.id,
              title: data.name,
              description: data.description,
              version: data.version,
              availableOn: !_.isUndefined(data.availableOn)
                ? data.availableOn
                : [
                  { apple: false, url: "" },
                  { android: false, url: "" },
                  { web: false, url: "" },
                ],
              isActive: data.isActive,
              isMultiplePracticeSets: data.multiplePracticeSetsEnabled,
              url: data.icon && data.icon != "" ? data.icon : "assets/img/WG-1.jpg",
            };
            return data;
          });
          if (!_.isUndefined(this.appPermissionList) && this.appPermissionList.length != 0) {
            _.each(this.appList, (objs) => {
              let obj: any = objs;
              if (obj.title == "Memorization") {
                obj.url = "assets/img/Color_logo_Strtagem.png";
              }
              let find = _.findWhere(this.appPermissionList, { permission_desc: obj.title });
              if (!_.isUndefined(find)) {
                if (obj.title == "Vectoring Game") obj.title = "Basic Vectoring";
                else if (obj.title == "Advanced Vectoring Game") obj.title = "Advanced Vectoring";
                this.appLibraryList.push(obj);
              }
            });
            _.each(this.appList, (objs) => {
              let obj: any = objs;
              let find = _.findWhere(this.appPermissionList, { permission_desc: obj.title });
              if (!_.isUndefined(find)) {
                if (obj.title == "Word Jumble") {
                  obj.title = "WORD JUMBLE";
                }
              }
            });
          } else if (!_.isUndefined(this.appPermissionList) && this.appPermissionList.length == 0) {
            _.each(this.appList, (objs) => {
              let obj: any = objs;
              if (obj.title == "Memorization") {
                obj.url = "assets/img/Color_logo_Strtagem.png";
                firstData = obj;
              }
            });
          }
          if (firstData) this.appLibraryList.unshift(firstData);
          this.helperService.appLibraryData$.next(this.appLibraryList);
          this.selectedApp = this.appLibraryList[0];
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  isload: boolean = false;
  initData() {
    this.datePickerEvent.selectedApp = this.selectedApp;
    if (this.userData.userName) {
      if (this.selectedApp && this.selectedApp?.title !== "STARS Keyboard") {
        this.getUserDetails(this.userData.userName);
      }
      this.getTeams(this.userData.userName);
      this.getCompletedPracticeSet(this.type, this.userData.userName);
    }
    this.api.changeMessage(this.datePickerEvent);
  }

  async getCompletedPracticeSet(type: any, name: string) {
    if (this.selectedApp?.title == "Advanced Vectoring" || this.selectedApp?.title == "Basic Vectoring" 
       || this.selectedApp?.title == "STARS Keyboard"
    ) {
      return;
    }
    var path = "";
    /*if (this.selectedApp.title == 'ATC Phraseology') {
      path = "/atc";
    }*/
    this.completedLessons = [];
    this.completedPracticeSets = [];
    this.isload = true;
    let apiUrl;
    let nameStr = this.crypto.isProbablyEncrypted(name) ? name : await this.crypto.encryptData(name);
    if (type.type == "Day" || type.type == "day" || type == null || type.type == null) {
      apiUrl = path + "/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=" + this.selectedApp.id + "&usageType=day&selectedUserName=" + nameStr;
    } else if (type.type == "Month" || type.type == "month") {
      apiUrl = path + "/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=" + this.selectedApp.id + "&usageType=month&selectedUserName=" + nameStr;
    } else if (type.type == "Year" || type.type == "year") {
      apiUrl = path + "/analytics/getUserAnalyticsCompletedPracticeSetDetails?gameId=" + this.selectedApp.id + "&usageType=year&selectedUserName=" + nameStr;
    } else if (type.type == "range") {
      apiUrl = path + "/analytics/getUserAnalyticsCompletedPracticeSetDetails?" + type.date + "&gameId=" + this.selectedApp.id + "&selectedUserName=" + nameStr;
    }
    this.api.get(apiUrl).subscribe(
      (success) => {
        if (success) {
          if (this.selectedApp.title == "ERAM Keyboard") {
            this.completedLessons = success.map((ps) => {
              const name = ps.lesson.split(" ");
              ps = {
                nameIcon: (name[0].split("")[0] ? name[0].split("")[0] : "") + (name[1] ? name[1].split("")[0] : (name[0].split("")[1] ? name[0].split("")[1] : "") ? name[0].split("")[1] : ""),
                ...ps,
              };
              ps["completionDate"] = moment(new Date(ps["completionDate"])).format("MMMM D, YYYY");
              const ob = { value: ps.practiceSetId, hide: true };
              ps.practiceSetId = ob;
              return ps;
            });
          } else if (this.selectedApp.title == "ATC Phraseology") {
            this.completedPracticeSets = success.map((ps) => {
              const name = ps.practiceSet.split(" ");

              const nameIcon =
                (name[0]?.[0] || "") +
                (name[1]?.[0] || name[0]?.[1] || "");

              return {
                nameIcon: nameIcon,
                practiceSet: ps.practiceSet,
                color: ps.color,
                sessionPlayed: ps.sessionPlayed,
                wordPerMin: ps.wordPerMin,
                completionDate: moment(new Date(ps.completionDate)).format("MMMM D, YYYY"),
                practiceSetId: { value: ps.practiceSetId, hide: true },
                ...(ps.status && { status: ps.status })
              };
            });
          } else {
            this.completedPracticeSets = success.map((ps) => {
              const name = ps.practiceSet.split(" ");
              ps = {
                nameIcon: (name[0].split("")[0] ? name[0].split("")[0] : "") + (name[1] ? name[1].split("")[0] : (name[0].split("")[1] ? name[0].split("")[1] : "") ? name[0].split("")[1] : ""),
                ...ps,
              };
              ps["completionDate"] = moment(new Date(ps["completionDate"])).format("MMMM D, YYYY");
              const ob = { value: ps.practiceSetId, hide: true };
              ps.practiceSetId = ob;
              return ps;
            });
          }
        }
        this.isload = false;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
    if (this.subSink1) this.subSink1.unsubscribe();
    this.api.changeCompletedMessage(false);
    this.helperService.setCompletedAppData(false);
  }

  trackByApp(index: number, item: any) {
    return item?.id || item?.title;
  }
}
